/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantData, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantDataFromJSONTyped, FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantDataToJSON, } from './FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantData';
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramFromJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramFromJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantData(json)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramToJSON(json) {
    return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramToJSONTyped(json, false);
}
export function FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantData(value)) {
        return FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegramMerchantDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreCreatePaymentHandlerCreatePaymentPublicResultTelegram.js.map